.recordingClip {
  display: flex;
  position: relative;
  height: 100%;
  margin: 8px 0;
  background-color: var(--tuna-palette-secondary-light);
  border: 1px solid var(--tuna-palette-action-focus);
  border-radius: var(--tuna-shape-radius-md);
  opacity: 0.5;
}

.recordingWav {
  flex: 1;
  display: flex;
  height: 100%;
}

.waveContainer {
  display: flex;
  flex: 1;
  justify-content: center;
}
